import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import Card from "@mui/material/Card";


function StatsCards({ stats }) {
  const getTierInfo = () => {
    const { referralsByTier, currentTier } = stats;
    const totalReferrals = stats.activeReferrals;
    const nextTierThreshold = currentTier === 1 ? 50 : currentTier === 2 ? 100 : null;
    
    if (nextTierThreshold) {
      const remaining = nextTierThreshold - totalReferrals;
      return `Tier ${currentTier}: ${remaining} more referrals to earn ${currentTier === 1 ? '30%' : '40%'} commission (51+ for 30%, 101+ for 40%).`;
    }
    return `You are in the maximum tier (Tier 3). Every referral from now on earns you 40% commission.`;
  };

  const getAverageEarnings = () => {
    if (!stats.activeReferrals) return '$0.00';
    return `$${(stats.monthlyRevenue / stats.activeReferrals).toFixed(2)} per referral/month`;
  };

  const getReferralBreakdown = () => {
    const { referralsByTier } = stats;
    const breakdown = [];
    
    // Clearer tier explanation
    if (referralsByTier.tier1) {
      breakdown.push(`${referralsByTier.tier1} referrals @ 20% (first 50)`);
    }
    if (referralsByTier.tier2) {
      breakdown.push(`${referralsByTier.tier2} referrals @ 30% (51-100)`);
    }
    if (referralsByTier.tier3) {
      breakdown.push(`${referralsByTier.tier3} referrals @ 40% (101+)`);
    }
    return breakdown.join(' | ');
  };
  

  const cards = [
    {
      title: "Total Lifetime Earnings",
      value: `$${stats.totalEarnings.toFixed(2)}`,
      subtitle: getAverageEarnings(),
      icon: "paid",
      color: "info"
    },
    {
      title: "Active Referrals",
      value: stats.activeReferrals,
      subtitle: getTierInfo(),
      secondSubtitle: `Current Commission Tier: ${['20%', '30%', '40%'][stats.currentTier - 1]}`,
      thirdSubtitle: getReferralBreakdown(),
      icon: "people",
      color: "success"
    },
{
  title: "Monthly Revenue",
  value: `$${Number(stats.activeMonthlyRecurringCommissionTotal || 0).toFixed(2)}`,
  subtitle: `Based on ${stats.activeMonthlyReferrals || 0} active monthly referrals`,
  secondSubtitle: "Recurring monthly commission (annual signups excluded)",
  icon: "trending_up",
  color: "primary"
},
    {
      title: "Available for Payout",
      value: `$${stats.availableForPayout.toFixed(2)}`,
      subtitle: "Available for payout is based on pending payments",
      secondSubtitle: "Min. Payout: $10",
      icon: "account_balance_wallet",
      color: "warning"
    }
  ];

  return (
    <Grid container spacing={3}>
      {cards.map((card, index) => (
        <Grid item xs={12} md={3} key={index}>
          <Card>
            <MDBox 
              p={3} 
              display="flex" 
              justifyContent="space-between"
              height="180px" // Fixed height for all cards
            >
              <MDBox 
                display="flex" 
                flexDirection="column" 
                justifyContent="space-between"
              >
                <MDBox>
                  <MDTypography 
                    variant="h6" 
                    fontWeight="medium" 
                    color="text"
                    mb={1}
                  >
                    {card.title}
                  </MDTypography>
                  <MDTypography 
                    variant="h4" 
                    fontWeight="bold"
                    mb={1}
                  >
                    {card.value}
                  </MDTypography>
                </MDBox>
                <MDBox>
                  {card.subtitle && (
                    <MDTypography 
                      variant="caption" 
                      color="text"
                      display="block"
                      mb={0.5}
                    >
                      {card.subtitle}
                    </MDTypography>
                  )}
                  {card.secondSubtitle && (
                    <MDTypography 
                      variant="caption" 
                      color="text" 
                      display="block"
                    >
                      {card.secondSubtitle}
                    </MDTypography>
                  )}
                </MDBox>
              </MDBox>
              <MDBox 
                display="flex" 
                alignItems="flex-start"
                pt={1}
              >
                <Icon fontSize="large" color={card.color}>{card.icon}</Icon>
              </MDBox>
            </MDBox>
          </Card>
        </Grid>
      ))}
    </Grid>
  );
}

export default StatsCards;